/* Nūvo — Build a Pack.
   Holds the pack client-side (variant id -> {qty, price, name}), works out which
   tier the vial count has reached, and shows separate vs pack pricing. Adding to
   cart posts every chosen variant in one /cart/add.js call.

   The tier maths here is DISPLAY ONLY. Nothing in the theme can discount a cart
   — that must come from a real discount (an app with a cart-quantity condition,
   or an automatic discount). While the section's `discount_active` is off the
   page says so rather than promising a price checkout won't honour.

   The add-to-cart deliberately calls window.fetch so nuvo-cart-open.js (which
   wraps fetch) sees it and re-renders the drawer. This file never reassigns
   window.fetch itself. */
(function () {
  'use strict';
  if (window.__nuvoPackInit) return;
  window.__nuvoPackInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB',
        { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP' })
        .format(cents / 100);
    } catch (e) { return '£' + (cents / 100).toFixed(2); }
  }

  // Briefly show a message on a button, then restore it.
  function flash(btn, msg) {
    if (!btn) return;
    if (btn.dataset.flashing) return;
    var original = btn.textContent;
    btn.dataset.flashing = '1';
    btn.textContent = msg;
    btn.classList.add('is-warn');
    setTimeout(function () {
      btn.textContent = original;
      btn.classList.remove('is-warn');
      delete btn.dataset.flashing;
    }, 1800);
  }

  // The variant a card would add right now (its dose select, or its only one).
  function cardVariant(item) {
    var sel = item.querySelector('[data-pack-dose]');
    if (sel) return sel.value;
    var single = item.querySelector('[data-pack-single]');
    return single ? single.getAttribute('data-variant') : null;
  }

  function init(sec) {
    var live = sec.getAttribute('data-live') === '1';
    var mode = sec.getAttribute('data-mode') || 'tiers';
    var freeQty = parseInt(sec.getAttribute('data-freeqty'), 10) || 5;
    var pack = Object.create(null);   // variantId -> {qty, price, name}

    var els = {
      tiers: Array.prototype.slice.call(sec.querySelectorAll('[data-pack-tier]')),
      count: sec.querySelector('[data-pack-count]'),
      unit: sec.querySelector('[data-pack-unit]'),
      progress: sec.querySelector('[data-pack-progress]'),
      nudge: sec.querySelector('[data-pack-nudge]'),
      slots: sec.querySelector('[data-pack-slots]'),
      sub: sec.querySelector('[data-pack-sub]'),
      total: sec.querySelector('[data-pack-total]'),
      save: sec.querySelector('[data-pack-save]'),
      asTitle: sec.querySelector('[data-pack-astitle]'),
      submit: sec.querySelector('[data-pack-submit]'),
      filter: sec.querySelector('[data-pack-filter]'),
      tray: sec.querySelector('[data-pack-tray]'),
      mini: sec.querySelector('[data-pack-mini]'),
      toggle: sec.querySelector('[data-pack-toggle]'),
      items: Array.prototype.slice.call(sec.querySelectorAll('[data-pack-item]'))
    };

    var target = null;   // the tier the shopper is aiming at (drives slot count)

    var tiers = els.tiers.map(function (t) {
      return {
        el: t,
        vials: parseInt(t.getAttribute('data-vials'), 10) || 0,
        percent: parseFloat(t.getAttribute('data-percent')) || 0
      };
    }).sort(function (a, b) { return a.vials - b.vials; });
    target = tiers[0] || null;

    function totals() {
      var qty = 0, sub = 0;
      Object.keys(pack).forEach(function (id) {
        qty += pack[id].qty;
        sub += pack[id].qty * pack[id].price;
      });
      return { qty: qty, sub: sub };
    }

    function reachedTier(qty) {
      var hit = null;
      tiers.forEach(function (t) { if (qty >= t.vials) hit = t; });
      return hit;
    }
    function nextTier(qty) {
      for (var i = 0; i < tiers.length; i++) if (qty < tiers[i].vials) return tiers[i];
      return null;
    }

    // Flatten the pack into one entry per vial, cheapest first — used by the
    // cheapest-free maths and by the slot rendering.
    function unitList() {
      var units = [];
      Object.keys(pack).forEach(function (id) {
        for (var i = 0; i < pack[id].qty; i++) units.push({ id: id, it: pack[id] });
      });
      return units;
    }

    // Shopify's BXGY takes the cheapest eligible item per qualifying group, so
    // mirror that: sort ascending and free every (freeQty)th item.
    function freeUnitKeys(units) {
      var byPrice = units.slice().sort(function (a, b) { return a.it.price - b.it.price; });
      var groups = Math.floor(units.length / freeQty);
      var free = [];
      for (var g = 0; g < groups; g++) free.push(byPrice[g]);
      return free;
    }

    function render() {
      var t = totals();
      var hit = reachedTier(t.qty);
      var next = nextTier(t.qty);
      var pct = hit ? hit.percent : 0;
      // Mirror Shopify's allocation exactly: an "amount off products" discount
      // is applied per LINE and the per-line discount is FLOORED, not rounded.
      // Measured on a real cart — £129.45 at 15% discounts £19.37, which is the
      // floored per-line sum; rounding gives £19.43 and taking 15% off the
      // subtotal gives £19.42, both of which quote the shopper a total the
      // cart then disagrees with.
      var packTotal = Object.keys(pack).reduce(function (sum, id) {
        var line = pack[id].price * pack[id].qty;
        return sum + line - Math.floor(line * pct / 100);
      }, 0);

      var units = unitList();
      var freeUnits = [];
      if (mode === 'cheapest') {
        freeUnits = freeUnitKeys(units);
        var off = freeUnits.reduce(function (n, u) { return n + u.it.price; }, 0);
        packTotal = t.sub - off;
        pct = t.sub ? Math.round((off / t.sub) * 100) : 0;
        next = t.qty % freeQty === 0 && t.qty > 0
          ? { vials: t.qty + freeQty, percent: 0 }
          : { vials: (Math.floor(t.qty / freeQty) + 1) * freeQty, percent: 0 };
        hit = freeUnits.length ? { vials: freeQty, percent: pct } : null;
      }

      els.count.textContent = t.qty;
      if (els.unit) els.unit.textContent = t.qty === 1 ? 'item' : 'items';

      tiers.forEach(function (x) {
        x.el.classList.toggle('is-reached', !!hit && x.vials <= hit.vials);
        x.el.classList.toggle('is-target', target === x);
      });

      // progress runs toward the next tier, or is full once the top tier is hit
      if (els.progress) {
        var pctBar;
        if (mode === 'cheapest') {
          pctBar = ((t.qty % freeQty) / freeQty) * 100;
          if (t.qty && t.qty % freeQty === 0) pctBar = 100;
        } else if (!next) pctBar = t.qty ? 100 : 0;
        else {
          var floor = hit ? hit.vials : 0;
          pctBar = Math.max(0, Math.min(100, ((t.qty - floor) / (next.vials - floor)) * 100));
        }
        els.progress.style.width = pctBar + '%';
      }

      if (els.nudge) {
        if (mode === 'cheapest') {
          var need2 = next ? next.vials - t.qty : 0;
          els.nudge.textContent = need2 > 0
            ? (freeUnits.length
                ? 'Add ' + need2 + ' more for another free vial'
                : 'Add ' + need2 + ' more and your cheapest vial is free')
            : '';
        } else if (next) {
          var need = next.vials - t.qty;
          els.nudge.textContent = 'Add ' + need + ' more for ' + next.percent + '% off';
        } else if (hit) {
          els.nudge.textContent = 'Top tier reached — ' + hit.percent + '% off';
        } else {
          els.nudge.textContent = '';
        }
      }

      // Slots: one per vial. Filled slots show the vial; the rest are numbered
      // placeholders up to whichever is larger — the target tier or what's in.
      if (els.slots) {
        var slotCount = Math.max(
          mode === 'cheapest' ? Math.max(freeQty, Math.ceil((units.length || 1) / freeQty) * freeQty) : (target ? target.vials : 0),
          units.length);
        var html = '';
        for (var s2 = 0; s2 < slotCount; s2++) {
          var u = units[s2];
          if (u) {
            var isFree = freeUnits.indexOf(u) !== -1;
            html += '<li class="nuvo-pack__slot nuvo-pack__slot--full' + (isFree ? ' nuvo-pack__slot--free' : '') + '">' +
              (u.it.img ? '<img src="' + u.it.img + '" alt="" loading="lazy">' : '') +
              '<span class="nuvo-pack__slot-n">' + u.it.name + '</span>' +
              '<button type="button" class="nuvo-pack__slot-x" data-pack-remove="' + u.id + '" aria-label="Remove ' + u.it.name + '">&times;</button>' +
              (isFree ? '<span class="nuvo-pack__slot-free">Free</span>' : '') +
              '</li>';
          } else {
            html += '<li class="nuvo-pack__slot nuvo-pack__slot--empty">' + (s2 + 1) + '</li>';
          }
        }
        els.slots.innerHTML = html;
      }

      if (!t.qty) {
        els.sub.textContent = els.total.textContent = els.save.textContent = '—';
      } else {
        els.sub.textContent = money(t.sub);
        els.total.textContent = money(packTotal);
        els.save.textContent = pct ? money(t.sub - packTotal) + ' (' + pct + '%)' : money(0);
      }
      if (els.asTitle) {
        if (mode === 'cheapest') {
          els.asTitle.textContent = freeUnits.length
            ? 'With ' + freeUnits.length + ' free' + (freeUnits.length > 1 ? ' vials' : ' vial')
            : 'Your total';
        } else if (hit) {
          els.asTitle.textContent = 'As a pack (' + hit.percent + '% off)';
        }
      }

      // The button shows what they will ACTUALLY be charged: the pack price only
      // once the discount is live, otherwise the undiscounted total.
      var payable = live ? packTotal : t.sub;
      els.submit.disabled = t.qty === 0;
      els.submit.textContent = t.qty
        ? 'Add ' + t.qty + ' to cart — ' + money(payable)
        : (els.submit.getAttribute('data-label') || 'Add pack to cart');

      // Count badge on each product card, for the variant that card would add.
      els.items.forEach(function (item) {
        var id = cardVariant(item);
        var n = id && pack[id] ? pack[id].qty : 0;
        var badge = item.querySelector('[data-pack-item-n]');
        if (badge) {
          badge.textContent = '\u00d7' + n;   // ×N
          badge.hidden = n === 0;
        }
        item.classList.toggle('is-in', n > 0);
      });

      // Collapsed bottom-sheet header: running count + what they'd pay.
      if (els.mini) els.mini.textContent = t.qty ? money(payable) : '';
    }

    function addVariant(item) {
      var sel = item.querySelector('[data-pack-dose]');
      var single = item.querySelector('[data-pack-single]');
      var id, price;
      if (sel) {
        var opt = sel.options[sel.selectedIndex];
        id = sel.value; price = parseInt(opt.getAttribute('data-price'), 10);
      } else if (single) {
        id = single.getAttribute('data-variant'); price = parseInt(single.getAttribute('data-price'), 10);
      }
      if (!id || isNaN(price)) return;

      // Stock ceiling. /cart/add.js rejects the WHOLE request if any one line
      // exceeds availability, so a pack holding 2 of a 1-in-stock vial used to
      // fail silently at the last step. Refuse the add here instead.
      var maxAttr = sel ? sel.options[sel.selectedIndex].getAttribute('data-max')
                        : single.getAttribute('data-max');
      var max = maxAttr === '' || maxAttr === null ? Infinity : parseInt(maxAttr, 10);
      if (isNaN(max)) max = Infinity;
      if (pack[id] && pack[id].qty >= max) {
        flash(item.querySelector('[data-pack-add]'),
              max === 1 ? 'Only 1 in stock' : 'Only ' + max + ' in stock');
        return;
      }
      // Slot labels are small — drop the boilerplate suffix our titles carry
      // ("... - Research Grade", "... | Research Grade") and any trailing
      // pipe-separated tail, so the compound name is what shows.
      var name = item.querySelector('.nuvo-pack__name').textContent.trim()
        .replace(/\s*[-|—]\s*Research Grade\s*$/i, '')
        .replace(/\s*\|\s*$/, '')
        .trim();
      if (sel) name += ' ' + sel.options[sel.selectedIndex].textContent.split('—')[0].trim();
      var thumb = item.querySelector('.nuvo-pack__thumb img');
      if (!pack[id]) pack[id] = { qty: 0, price: price, name: name, img: thumb ? thumb.getAttribute('src') : '', max: max };
      pack[id].max = max;
      pack[id].qty += 1;
      render();
    }

    sec.addEventListener('click', function (e) {
      var add = e.target.closest('[data-pack-add]');
      if (add) { e.preventDefault(); addVariant(add.closest('[data-pack-item]')); return; }
      var rm = e.target.closest('[data-pack-remove]');
      if (rm) {
        e.preventDefault();
        var id = rm.getAttribute('data-pack-remove');
        if (pack[id]) { pack[id].qty -= 1; if (pack[id].qty <= 0) delete pack[id]; }
        render();
        return;
      }
      var tierBtn = e.target.closest('[data-pack-tier]');
      if (tierBtn) {
        e.preventDefault();
        for (var i = 0; i < tiers.length; i++) if (tiers[i].el === tierBtn) target = tiers[i];
        render();
        return;
      }
      if (e.target.closest('[data-pack-toggle]')) {
        e.preventDefault();
        var open = els.tray.classList.toggle('is-open');
        els.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      if (e.target.closest('[data-pack-submit]')) { e.preventDefault(); submit(); }
    });

    // Switching dose changes which variant the card represents, so the badge
    // has to follow the selection rather than the product.
    sec.addEventListener('change', function (e) {
      if (e.target.closest('[data-pack-dose]')) render();
    });

    if (els.filter) {
      els.filter.addEventListener('input', function () {
        var q = els.filter.value.trim().toLowerCase();
        sec.querySelectorAll('[data-pack-item]').forEach(function (it) {
          it.hidden = q ? it.getAttribute('data-name').indexOf(q) === -1 : false;
        });
      });
    }

    function submit() {
      var items = Object.keys(pack).map(function (id) {
        return { id: Number(id), quantity: pack[id].qty };
      });
      if (!items.length) return;
      var btn = els.submit, label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      // window.fetch, NOT the captured origFetch: nuvo-cart-open.js wraps fetch
      // to re-render the drawer's contents and the count bubble after a
      // successful add. Going around it opened a drawer still showing its old,
      // empty markup — which looked exactly like "nothing was added".
      window.fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            // A 422 (usually availability) used to fall through to "Added ✓".
            if (!r.ok) throw new Error((data && (data.description || data.message)) || 'Could not add');
            return data;
          });
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          Object.keys(pack).forEach(function (k) { delete pack[k]; });
          target = null;
          render();
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
        })
        .catch(function (err) {
          var msg = (err && err.message) || '';
          // Shopify's availability wording is long; keep the button readable.
          btn.textContent = /availab/i.test(msg) ? 'Not enough stock' : 'Could not add — try again';
          btn.classList.add('is-warn');
          setTimeout(function () {
            btn.textContent = label;
            btn.disabled = false;
            btn.classList.remove('is-warn');
          }, 2600);
        });
    }

    if (els.unit) els.unit.setAttribute('data-plural', els.unit.textContent);
    els.submit.setAttribute('data-label', els.submit.textContent.trim());
    render();
    if (!live) sec.setAttribute('data-preview', '1');
  }

  function boot() {
    document.querySelectorAll('[data-nuvo-pack]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
